module.exports = __webpack_public_path__ + "img/analytics-payment-bg.7f618f92.svg";